/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RqthReviewStatusResource = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Refused: 'REFUSED',
    ExpiringSoon: 'EXPIRING_SOON',
    Expired: 'EXPIRED'
} as const;
export type RqthReviewStatusResource = typeof RqthReviewStatusResource[keyof typeof RqthReviewStatusResource];


export function instanceOfRqthReviewStatusResource(value: any): boolean {
    for (const key in RqthReviewStatusResource) {
        if (Object.prototype.hasOwnProperty.call(RqthReviewStatusResource, key)) {
            // @ts-ignore
            if (RqthReviewStatusResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RqthReviewStatusResourceFromJSON(json: any): RqthReviewStatusResource {
    return RqthReviewStatusResourceFromJSONTyped(json, false);
}

export function RqthReviewStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RqthReviewStatusResource {
    return json as RqthReviewStatusResource;
}

export function RqthReviewStatusResourceToJSON(value?: RqthReviewStatusResource | null): any {
    return value as any;
}

